export default __webpack_public_path__ + "static/media/1981.a8a4dfa3.png";